module.exports = __webpack_public_path__ + "img/background5.3d5c25d0.jpg";